import { RightType } from "../../../Global/Base/Rights/RightTypes";
import { ILogicalComponent } from "./ILogicalComponent";

export interface ILogicalContainer extends ILogicalComponent {
    readonly isContainer: boolean;

    /**
     * Pro daný typ práva zaregistruje nový pending promise pouze v případě, že ještě neexistuje nebo je aktuální settled.
     * @param rightType Typ práva
     */
    tryToCreatePendingRightEvaluation(rightType: RightType): boolean;

    /**
     * Umožnuje čekat na dokončení probíhajícího vyhodnocení konkrétního typu práva.
     * @param rightType Typ práva
     */
    waitForRightTypeEvaluation(rightType: RightType): Promise<boolean>;

    /**
     * Resolvne promise pro daný typ práva, pokud takový existuje. Volá se v případě dokončení vyhodnocení.
     * @param rightType Typ práva
     */
    resolvePendingRightTypeEvaluation(rightType: RightType): boolean;
}

export class ILogicalContainer {
    private static _properties: (keyof ILogicalContainer)[] = ["isContainer"];
    private static _methods: (keyof(ILogicalContainer))[] = ["tryToCreatePendingRightEvaluation", "waitForRightTypeEvaluation", "resolvePendingRightTypeEvaluation"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._properties.some((value) => !Reflect.has(instance, value)) &&
            !this._methods.some(value => typeof instance[value] !== "function");
    }
}
